import * as Sentry from "@sentry/tanstackstart-react";
import { createMiddleware } from "@tanstack/react-start";
import { skewRedirect } from "#/modules/util.instrumentation/middleware.version-skew";

// TanStack's error for an id missing from this build's manifest (server-fn-resolver-module.ts). If
// upstream answers 404 instead (TanStack/router#7363) this stops matching; see the runbook check.
const UNKNOWN_SERVER_FN = "Server function info not found for ";

/**
 * The skew guard for a server fn this build no longer has (renamed, moved or removed). TanStack
 * resolves the id before any function middleware runs, so `versionSkewMiddleware` never sees the
 * call. Same redirect, thrown here: Start serializes it for the stale tab, whose client half
 * reloads onto this build.
 */
export const unknownServerFnMiddleware = createMiddleware().server(
  async ({ next, handlerType, request, pathname }) => {
    const serverVersion = process.env.APP_VERSION;
    if (handlerType !== "serverFn" || !serverVersion) return next();
    try {
      return await next();
    } catch (error) {
      if (!(error instanceof Error && error.message.startsWith(UNKNOWN_SERVER_FN))) throw error;
      // A crawler replaying a cached id is not a tab that can reload.
      if (request.headers.get("x-tsr-serverFn") !== "true") {
        return new Response(null, { status: 404 });
      }
      Sentry.logger.info("version skew: unknown server fn", {
        "url.path": pathname,
        "http.referer": request.headers.get("referer") ?? "",
      });
      throw skewRedirect(serverVersion);
    }
  },
);
